import { helpers } 		from './sites/helpers.js';
import { example } 		from './sites/components/exapmple.js';

window.sites_extended = {
	globals: {},

	init: function () {
		var self = this;

		example.init();

		self.calendarThings();
		
	},

	setCalendarViaType( showType, calendar, $section ) {
		if( showType == "training" ) {
			calendar.changeView('dayGridWeek');
			jQuery( '.fc-view-harness').addClass( 'week-view' ); 
		}
		else {
			calendar.changeView('dayGridMonth');
			jQuery( '.fc-view-harness').removeClass( 'week-view' ); 
		}
		calendar.render();

		$section.find( '.fc-event' ).addClass( 'd-none' );
		$section.find( '.' + showType ).removeClass( 'd-none' );

		if( showType == "all" ) {
			$section.find( '.fc-event' ).removeClass( 'd-none' );
		}		
	},

	calendarThings() {
		var self = this;
		var calendars = document.querySelectorAll('.js-calendar');

		for (let i = 0; i < calendars.length; i++) {
			let calendarEl = calendars[i];
			
			let calendar = new FullCalendar.Calendar(calendarEl, {
				initialView: 'dayGridMonth', //dayGridWeek   dayGridMonth
				locale: 'cs',
				eventRender: function(event, element) {
					console.log("asdasd");
				}
			});

			calendar.render();
			
			calendar.addEventSource( competitions);

			//Update data, when calendar reendered
			jQuery(document).on( 'click', '.fc-button', function(e) {
				let showType = jQuery( '.js-calendar-navigation li a.active' ).data( 'type' );
				self.setCalendarViaType( showType, calendar, jQuery( calendars[i] ).closest('section') );
			});

			//Class for desible our styles
			jQuery( '.fc' ).find( 'table' ).addClass( 'datepick' );

			//Default show
			let showType = jQuery( '.js-calendar-navigation li' ).first().find( 'a' ).data( 'type' );
			self.setCalendarViaType( showType, calendar, jQuery( calendars[i] ).closest('section') );
			jQuery( '.js-calendar-navigation li' ).first().find( 'a' ).addClass( 'button--primary active').removeClass( 'button--primary-ghost');


			jQuery(document).on( 'click', '.js-calendar-navigation a', function(e) {
				e.preventDefault();

				jQuery( this ).closest('.js-calendar-navigation').find( '.button--primary' ).addClass( 'button--primary-ghost').removeClass( 'button--primary active' );
				jQuery( this ).addClass( 'button--primary').removeClass( 'button--primary-ghost').addClass('active');
		
				let showType = jQuery(this).data( 'type' );

				self.setCalendarViaType( showType, calendar, jQuery(this).closest('section') );
			})
		}
	},

	onresize() {
		var self = this;
	},

	onscroll(position, previusPosition) {
		var self = this;
	},
};

jQuery(document).ready(function ($) {
	sites_extended.init();
});

window.addEventListener('scroll', function (e) {
	sites_extended.onscroll();
});

window.addEventListener('resize', function (e) {
	sites_extended.onresize();
});